import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App, { syncDesignColors } from "./App.jsx";
import AcceptInvite from "./AcceptInvite.jsx";
import CreateFamily from "./CreateFamily.jsx";
import JoinWithCode from "./JoinWithCode.jsx"; // "Kodi i Familjes" — bashkim vetë-shërbyes
// DOKUMENTET JURIDIKE — NJË FAQE, ZERO TEKST BRENDA
//
// `TermsOfService.jsx` dhe `PrivacyPolicy.jsx` mbanin secili nga një kopje të
// shkruar me dorë të tekstit. Ajo e privatësisë ishte mbetur një draft i 3
// gushtit, PUBLIK, me shënime drejtuar juristit brenda — ndërsa dokumenti i
// vërtetë ishte ngarkuar prej kohësh te «Rreth platformës».
//
// Tani të dyja rrugët shërbejnë të njëjtin komponent, i cili e merr tekstin nga
// tabela `documents` (shih PUBLIK1_dokumentet_publike.sql). Një ngarkim i ri te
// Admin Center e ndryshon faqen menjëherë, pa deploy dhe pa kopje që vjetrohet.
import DokumentPublik from "./DokumentPublik.jsx";
import FshijLlogarine from "./FshijLlogarine.jsx"; // GOOGLE PLAY — URL publike e fshirjes së llogarisë
import i18n from "./i18n"; // FAZA 10 — duhet inicializuar para se ndonjë komponent të përdorë useTranslation()
import "./index.css";
import { initDesign } from "./designLoader"; // Design Studio — vendos tokenat e dizajnit aktiv (CSS vars) + live update në publish
import { nisDiagnozen } from "./diagnoza"; // ⚠ I PËRKOHSHËM — hiqet para lansimit (shih diagnoza.js)
import { prova, EkraniProves } from "./prova.jsx"; // ⚠ I PËRKOHSHËM — çelësi i provës ndarëse

// ═══════════════════════════════════════════════════════════════════════════
// PROVA NDARËSE — numri caktohet te `prova.jsx`, jo këtu.
//
// PROVA 1 e mbylli pyetjen e parë: numri kaloi 90 pa u kthyer kurrë te 0, pra
// guaska (Capacitor + shtojcat + WebView) është e shëndoshë. Nga PROVA 2 e
// tutje nisja bëhet plotësisht normale — dizajni, i18n, Sentry, `App`-i — dhe
// ndarja zhvendoset brenda `App.jsx`, te kufiri i vërtetë: identifikimi.
// ═══════════════════════════════════════════════════════════════════════════
const prova1 = prova(1);

// ── DIAGNOSTIKË NISJEJE (telefon/native) ──────────────────────────────────
// Në app-in e instaluar konsola s'shihet lehtë. Nëse nisja rrëzohet (para se
// React të montohet), zakonisht mbetet "ekran i bardh" pa asnjë të dhënë. Ky
// kapës e shkruan gabimin REAL DIREKT në ekran, që të bëhet screenshot nga
// telefoni. Aktivizohet VETËM nëse #root ka mbetur bosh (app-i s'u montua) —
// pra s'e prek kurrë një app që punon.
(function installBootErrorOverlay() {
  function showBootError(where, msg) {
    try {
      const el = document.getElementById("root");
      if (!el || el.hasChildNodes()) return; // app-i u montua → mos e prek
      el.innerHTML =
        '<div style="padding:18px;font:13px/1.5 -apple-system,system-ui,sans-serif;color:#3a0a13;background:#fff;min-height:100vh;">' +
        '<div style="font-weight:800;font-size:16px;margin-bottom:8px;">Gabim në nisje</div>' +
        '<div style="color:#7A2430;margin-bottom:10px;">' + String(where || "") + '</div>' +
        '<pre style="white-space:pre-wrap;word-break:break-word;background:#f6f2e7;border:1px solid #eae3d8;border-radius:8px;padding:12px;font:11px/1.5 monospace;color:#2A2118;">' +
        String(msg || "").replace(/&/g, "&amp;").replace(/</g, "&lt;") + '</pre></div>';
    } catch (_e) { /* asgjë */ }
  }
  try {
    window.addEventListener("error", (e) => showBootError("window.error", (e && e.error && e.error.stack) || (e && e.message) || String(e)));
    window.addEventListener("unhandledrejection", (e) => showBootError("unhandledrejection", (e && e.reason && (e.reason.stack || e.reason.message)) || String(e && e.reason)));
  } catch (_e) { /* asgjë */ }
})();

// ── SHIRITI I DIAGNOZËS ────────────────────────────────────────────────────
//
// ⚠ I PËRKOHSHËM, gusht 2026. Hiqet ky rresht dhe `diagnoza.js` para lansimit.
//
// Kapësi më sipër shkruan vetëm kur `#root` mbeti bosh — pra kur aplikacioni
// s'u montua fare. Por defekti që po ndjekim është i llojit tjetër: aplikacioni
// montohet, pamja del e plotë, dhe prekjet nuk bëjnë asgjë. Për atë gjendje ai
// kapës hesht, sepse `#root`-u është plot.
//
// `diagnoza.js` e mbulon pikërisht atë boshllëk. Ndizet vetëm te telefoni, ose
// te shfletuesi me `?diagnoza=1` — asnjë përdorues nuk e sheh rastësisht.
if (!prova1) { try { nisDiagnozen(); } catch (_e) { /* diagnoza s'guxon ta ndalë nisjen */ } }

// Faza 12/13 — apliko dizajnin AKTIV (nga Design Studio) para render-it dhe
// dëgjo publikimet live. Pa këtë, "Publish" te Design Studio s'prekte app-in.
// SIGURI (telefon/native): fire-and-forget me mbrojtje të plotë — asnjë gabim
// këtu s'guxon të bllokojë nisjen e app-it (as "ekran i bardh" para login-it).
if (!prova1) { try { const _d = initDesign(); if (_d && typeof _d.catch === "function") _d.catch(() => {}); } catch (_e) { /* nisja vazhdon gjithsesi */ } }
// Sinkronizo COLORS/FONTS nga dizajni i ruajtur (cache), i aplikuar sinkron te
// initDesign më sipër → render-i i parë përdor dizajnin e duhur (pa flash).
if (!prova1) { try { syncDesignColors(); } catch (_e) { /* jo-kritike */ } }

// FAZA 3 (VËZHGUESHMËRIA) — Sentry, VETËM nëse VITE_SENTRY_DSN është vendosur
// (Cloudflare Pages → Settings → Environment variables). Pa këtë env var,
// Sentry.init() thjesht s'bën asgjë (no-op) — s'e prish zhvillimin lokal, dhe
// s'kërkohet asnjë ndryshim tjetër kodi për ta "fikur" në ndonjë mjedis.
// DSN-në e merr nga sentry.io → Projects → (krijo projekt "React") → Settings.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE, // "production" / "development"
    tracesSampleRate: 0.1, // 10% e transaksioneve — mjafton për performancë, pa e mbushur planin falas shpejt
  });
}

// Rrugëzim i qëllimshëm i thjeshtë: s'ka nevojë për react-router. Pesë
// rrugë: /platform-admin (FAZA 1.5), /invite (FAZA 2), /start (FAZA 5 —
// krijimi i familjes së re), /join (Kodi i Familjes — bashkim vetë-
// shërbyes), dhe /f/{slug} (FAZA 5 — pema e një familjeje
// specifike, identifikuar nga slug-u i saj; shih App.jsx për si përdoret
// `familySlug`). Çdo URL tjetër (rrënja "/", ende pa `/f/`) mbetet
// instanca "parazgjedhje" — kështu deploy-i aktual i Halitit vazhdon të
// punojë saktësisht si më parë, pa asnjë ndryshim URL-je të domosdoshëm.
const path = window.location.pathname;
let RootComponent = App;
let familySlug = null;
// AUDITI 2026-08 — paneli i vjetër /platform-admin u hoq nga build-i.
// Ishte një ndërfaqe e dytë administrimi, e harruar por e gjallë: thërriste të
// njëjtin `rpc_platform_set_family_plan` si Admin Center-i, pa e ditur për të.
// Më 22 gusht 2026 skedari u FSHI. Ishte lënë "për çdo rast, kthim me një
// rresht" — dhe pikërisht ai një rresht ishte rreziku: një ndërfaqe e dytë
// administrimi, jashtë RBAC-it të Fazës 10, një `git revert` larg. Historia e
// git-it e mban nëse duhet lexuar.
if (path.startsWith("/invite")) RootComponent = AcceptInvite;
else if (path.startsWith("/start")) RootComponent = CreateFamily;
else if (path.startsWith("/join")) RootComponent = JoinWithCode; // "Kodi i Familjes"
else if (path.startsWith("/terms")) RootComponent = () => <DokumentPublik lloji="terms" />;
else if (path.startsWith("/privacy")) RootComponent = () => <DokumentPublik lloji="privacy" />;
else if (path.startsWith("/cookies")) RootComponent = () => <DokumentPublik lloji="cookies" />;
// FSHIRJA E LLOGARISË — e detyrueshme nga Google Play si URL publike (Data
// safety). Dy shkrime sepse rishikuesi shkruan anglisht dhe përdoruesi shqip;
// asnjëri nuk duhet të bjerë te ballina pa shpjegim.
else if (path.startsWith("/fshij-llogarine") || path.startsWith("/delete-account")) RootComponent = FshijLlogarine;
else if (path.startsWith("/f/")) familySlug = path.split("/")[2] || null;

// TE APLIKACIONI NATIVE RRUGA NUK EKZISTON.
//
// Te shfletuesi familja zgjidhet nga adresa: `/f/orlishta`. Brenda app-it faqet
// vijnë nga paketa lokale, dhe një rrugë e tillë s'është skedar — pra klikimi
// "Ndërro familjen" nuk çonte askund dhe butoni dukej i vdekur.
//
// Prandaj aty slug-u ruhet te pajisja dhe lexohet këtu. Ruhet vetëm nga vetë
// aplikacioni (`shkoTeFamilja`), pra s'ka si të vijë nga jashtë.
// 30 gusht 2026 — E NJËJTA RREGULL EDHE TE SHFLETUESI.
//
// Deri sot ky bllok kërkonte `Capacitor.isNativePlatform()`. Pasoja e pa
// pronari: hap `pemaefamiljes.com/` te kompjuteri, llogaria është e lidhur me
// dy familje — dhe prapë del ekrani «llogaria jote nuk është lidhur ende me
// asnjë profil në këtë pemë», me një listë familjesh për të zgjedhur. Një hap
// i tepërt në çdo hyrje, çdo herë.
//
// Shkaku ishte pikërisht ky kusht: pa slug te adresa dhe pa lexim nga pajisja,
// aplikacioni nisej pa familje, binte te një pemë ku ai person s'ekziston, dhe
// e raportonte këtë me plot të drejtë. Kujtesa ekzistonte; thjesht lexohej
// vetëm te telefoni.
//
// Prandaj lexohet kudo. Është e sigurt sepse:
//   · shkruhet VETËM nga `shkoTeFamilja` — pra është zgjedhja e vetë njeriut;
//   · një adresë e shprehur `/f/<slug>` e ka mbushur tashmë `familySlug`, dhe
//     `!familySlug` nuk e prek kurrë atë;
//   · `RootComponent === App` e mban jashtë çdo faqeje tjetër (/join, /privacy,
//     /invite…), ku familja s'ka fare kuptim.
if (!familySlug && RootComponent === App) {
  try { familySlug = localStorage.getItem("pef_family_slug") || null; } catch (_e) { /* private mode */ }
}

// FAZA 3a — /partner nuk është më faqe, është URË.
//
// Portali i partnerit (`PartnerPortal.jsx`) u hoq: partnerët hyjnë tani te
// "Puna", te i njëjti radhë me stafin, me të njëjtën llogari — dhe `fn_puna_role()`
// vendos se çfarë shohin. Dy ndërfaqe për të njëjtën punë do të thoshte dy vende
// ku duhet ndrequr çdo gjë, dhe një prej tyre do të harrohej.
//
// Por një rrugë e fshirë nuk zhduket nga faqeruajtësit e askujt. Pa këto tri
// rreshta, partneri që klikon lidhjen e vjetër do të gjendej para një peme
// familjeje që s'i takon — dhe do të mendonte se llogaria iu prish.
const teksPartneri = path.startsWith("/partner");
// SIGURIA2 (M4) — kur një gabim rrëzon pemën e React-it, njeriu duhet të ketë një
// buton, jo vetëm një udhëzim. Në telefon (WebView) s'ka as «rifresko» të
// shfletuesit: pa buton, e vetmja rrugëdalje ishte të mbyllte app-in me forcë.
function GabimiPaRifreskim() {
  return (
    <div style={{ padding: 24, fontFamily: "sans-serif", textAlign: "center" }}>
      <p>{i18n.t("Something went wrong. Reload the page — if it keeps happening, contact us.")}</p>
      <button
        type="button"
        onClick={() => { try { window.location.reload(); } catch (_e) { /* asgjë */ } }}
        style={{ marginTop: 12, padding: "10px 20px", fontSize: 16, borderRadius: 8, border: "1px solid #888", background: "transparent", cursor: "pointer" }}
      >
        {i18n.t("Reload")}
      </button>
    </div>
  );
}

if (prova1) {
  ReactDOM.createRoot(document.getElementById("root")).render(<EkraniProves etiketa="guaska" />);
} else if (teksPartneri) {
  window.location.replace("https://puna.pemaefamiljes.com/");
} else {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<GabimiPaRifreskim />}>
        {RootComponent === App ? <App familySlug={familySlug} /> : <RootComponent />}
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
}
